import { SVGProps } from 'react';

export const IconMenu = ({ ...props }: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 24 24' fill='currentColor' {...props}>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.75 6C4.75 5.44772 5.14345 5 5.62879 5H18.3712C18.8566 5 19.25 5.44772 19.25 6C19.25 6.55228 18.8566 7 18.3712 7H5.62879C5.14345 7 4.75 6.55228 4.75 6Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.75 12C4.75 11.4477 5.14345 11 5.62879 11H18.3712C18.8566 11 19.25 11.4477 19.25 12C19.25 12.5523 18.8566 13 18.3712 13H5.62879C5.14345 13 4.75 12.5523 4.75 12Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4.75 18C4.75 17.4477 5.14345 17 5.62879 17H18.3712C18.8566 17 19.25 17.4477 19.25 18C19.25 18.5523 18.8566 19 18.3712 19H5.62879C5.14345 19 4.75 18.5523 4.75 18Z'
        fill='currentColor'
      />
    </svg>
  );
};
